function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "angle-down-light",
  transform: "matrix(1.1924881E-08 1 -1 1.1924881E-08 8.144775 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.53525 7.95138L0.192736 1.51045C-0.0642453 1.25347 -0.0642453 0.837922 0.192736 0.580941L0.580941 0.192736C0.837922 -0.0642453 1.25347 -0.0642453 1.51045 0.192736L7 5.78617L12.4896 0.198203C12.7465 -0.0587776 13.1621 -0.0587776 13.4191 0.198203L13.8073 0.586409C14.0642 0.84339 14.0642 1.25893 13.8073 1.51591L7.46475 7.95684C7.20777 8.20836 6.79223 8.20836 6.53525 7.95138Z",
  id: "Path",
  stroke: "none"
}));
var SvgChevronLeft = function SvgChevronLeft(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "14px",
    viewBox: "0 0 9 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChevronLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-left.c58b8b29.svg";
export { ForwardRef as ReactComponent };